<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<mat-card>
					<mat-card-header>
						<mat-card-title
							><span
								[innerHtml]="`${screen.goalType.label}s` | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span
						></mat-card-title>
					</mat-card-header>

					<mat-card-content>
						<div
							class="layout-block vertical"
							[style.align-items]="'inherit'"
							[style.gap]="'1em'"
						>
							<div
								class="has-cdkDropListDropped-handler"
								(cdkDropListDropped)="handler_DropListBlock_13_cdkDropListDropped_$adhoc_0($event, { $disabled: $disabled })"
								cdkDropList
								[cdkDropListData]="[]"
								[cdkDropListOrientation]="'vertical'"
							>
								<div
									class="layout-block vertical"
									[style.align-items]="'inherit'"
									[style.gap]="'0.25em'"
								>
									<ng-container
										*ngFor="let goal of screen.goals; let goalIndex = index; trackBy: trackByAutomatic"
									>
										<ng-container *lowgileScope="goal; as: 'goal'; let $scope">
											<ng-container
												*lowgileScope="goalIndex; as: 'goalIndex'; let $scope"
											>
												<div
													cdkDrag
													[cdkDragData]="goal"
													[cdkDragDisabled]="$disabled"
													[cdkDragLockAxis]="'y'"
												>
													<mat-card>
														<mat-card-header>
															<mat-card-title
																><ng-container
																	*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(!screen.gs.status.employeeCanEdit && !screen.viewMode.isHr)) as $disabled"
																>
																	<div
																		class="layout-block"
																		[style.align-items]="'inherit'"
																		[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																		[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																		[style.gap]="'0.25em'"
																	>
																		<div
																			[style.display]="'contents'"
																			cdkDragHandle
																		>
																			<ng-container
																				*ngIf="!$disabled"
																				><mat-icon
																					[innerHtml]="'drag_indicator'"
																					fontSet="material-icons"
																					[inline]="false"
																				></mat-icon
																			></ng-container>
																		</div>
																		<span
																			[innerHtml]="`${screen.goalType.label} #${goalIndex + 1}` | escapeHtml: 'none' | replaceNewlines: 'span'"
																		></span>
																		<span
																			[style.flex]="'1 0 auto'"
																			[innerHtml]="'' | escapeHtml: 'none' | replaceNewlines: 'span'"
																		></span>
																		<ng-container
																			*ngIf="!$disabled"
																			><button
																				mat-icon-button
																				mat-small-icon-button
																				class="has-click-handler"
																				color="warn"
																				(click)="handler_ButtonBlock_20_click_$adhoc_0($event, { goal, goalIndex, $disabled: $disabled })"
																				[disabled]="$disabled"
																			>
																				<mat-icon
																					>{{'delete'}}</mat-icon
																				>
																			</button></ng-container
																		>
																	</div>
																</ng-container></mat-card-title
															>
														</mat-card-header>

														<mat-card-content>
															<Toolbox-GoalSettingGoalInclude
																[$formDirective]="$formDirective"
																[$disabled]="$disabled"
																[$ignoreValidations]="$ignoreValidations"
																[gs]="screen.gs"
																[goal]="goal"
																[viewMode]="screen.viewMode"
																[columnVisibility]="screen.columnVisibility"
															>
															</Toolbox-GoalSettingGoalInclude>
														</mat-card-content>
													</mat-card>
												</div>
											</ng-container>
										</ng-container>
									</ng-container>
								</div>
							</div>
							@let $fc_27 = getFormControl(screen.goals, 'θvalidator_27', 27, $scope,
							$formDirective, $disabled, $ignoreValidations);
							<div
								*ngIf="$fc_27 | hasValidatorError: $validators[27] : $scope | async"
								class="mat-mdc-form-field-error"
							>
								@for(error of $fc_27.errors | keyvalue; track error) {
								<div>{{error.value}}</div>
								}
							</div>

							<ng-container
								*ngIf="((screen.gs.status.employeeCanEdit && screen.viewMode.isEmployee) || (screen.gs.status.isSelfReviewDone && screen.viewMode.isManager && screen.goalType.futureGoal) || screen.viewMode.isHr) && !$disabled"
								><div
									class="layout-block"
									[style.align-items]="'inherit'"
									[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
									[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
									[style.gap]="'1em'"
								>
									<button
										mat-raised-button
										class="has-click-handler"
										color="primary"
										(click)="handler_ButtonBlock_8_click_$adhoc_0($event, { $disabled: $disabled })"
										[disabled]="$disabled"
									>
										<mat-icon>{{'add_circle'}}</mat-icon
										><span
											[innerHtml]="`Add ${screen.goalType.label.toLocaleLowerCase()}` | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
									</button></div
							></ng-container>
						</div>
					</mat-card-content>
				</mat-card>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
